import { useLocation } from 'react-router-dom';
import { CommunityQnaRouter } from '../../../../util/RouterUtil';
import ViewWrapper from '../../../ViewWrapper';

const CommunityQnaRouterView = () => {
    const pathname = useLocation().pathname;
    return <ViewWrapper router={CommunityQnaRouter} />;
};

export default CommunityQnaRouterView;
